import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

import { NELType } from '@insights_module/types/NEL';
import { searchLinkedNamedEntities } from '@services/index';

export function useSearchLinkedNamedEntities(searchTerm: string) {
  const { data, isLoading } = useQuery({
    queryKey: ['search-linked-named-entites', searchTerm],
    queryFn: () => searchLinkedNamedEntities(searchTerm),
    staleTime: 60 * 60 * 1000, // 1 hour
    enabled: !!searchTerm.length,
  });

  const loading = useMemo(() => isLoading && searchTerm?.length, [isLoading, searchTerm]);

  return {
    searchTerm,
    sugestions: data?.data?.linked_named_entities || ([] as NELType[]),
    isLoading: loading,
  };
}
